import { API } from '@aws-amplify/api';
import { PostInfractionInput } from '../../@types/infractions';

export async function postInfraction(input: PostInfractionInput): Promise<void> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = 'api/infractions';
    const myInit = {
      queryStringParameters: {},
      body: input,
    };

    await API.post(apiName, path, myInit);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
